import { render, staticRenderFns } from "./Collapsable.vue?vue&type=template&id=474c50eb&scoped=true"
import script from "./Collapsable.vue?vue&type=script&lang=js"
export * from "./Collapsable.vue?vue&type=script&lang=js"
import style0 from "./Collapsable.vue?vue&type=style&index=0&id=474c50eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474c50eb",
  null
  
)

export default component.exports